export default __webpack_public_path__ + "static/media/netbank-white.32f2b3c7.svg";